import { Env } from '../../Env';
import { EnvironmentServiceOutput } from './EnvironmentServiceOutput';
export class EnvironmentService {
    static instance;
    output;
    static getInstance() {
        if (!EnvironmentService.instance) {
            EnvironmentService.instance = new EnvironmentService();
        }
        return EnvironmentService.instance;
    }
    static getOutput() {
        return EnvironmentServiceOutput.getReactiveOutput();
    }
    // ------------- Singleton implementation end
    mobile = false;
    production = false;
    constructor() {
        this.output = new EnvironmentServiceOutput();
        this.detectIsMobile();
        this.detectIsProduction();
        this.publishOutput();
        this.output.setScreenOrientationType(screen.orientation.type);
        screen.orientation.addEventListener('change', () => this.output.setScreenOrientationType(screen.orientation.type));
    }
    async init() { }
    detectIsMobile() {
        const ua = navigator.userAgent || navigator.vendor || '';
        const isTouchCapable = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const uaMobile = /android|iphone|ipad|ipod|iemobile|blackberry|bada|tizen|windows phone|mobile/i.test(ua);
        // Heuristic: small viewport likely mobile
        const smallViewport = Math.min(window.innerWidth, window.innerHeight) <= 820;
        // Prefer UA/mobile flags, fall back to viewport/touch
        this.mobile = uaMobile || (isTouchCapable && smallViewport);
    }
    detectIsProduction() {
        this.production = Env.isProduction();
    }
    publishOutput() {
        this.output.setIsMobile(this.mobile);
        this.output.setIsProduction(this.production);
    }
    // Getters for other services
    getIsMobile() {
        return this.mobile;
    }
    getIsProduction() {
        return this.production;
    }
}
